import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addLandedCostVoucher = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Landed Cost Voucher',
    body
  );
  return data;
});
export const updateLandedCostVoucher = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Landed Cost Voucher/${id}`,
    body
  );
  return data;
});

export const getLandedCostVoucher = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Landed Cost Voucher?fields=["name","docstatus","total_taxes_and_charges"]&order_by=name desc&limit_start=0&limit_page_length=0';
    if (value) {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const deleteLandedCostVoucher = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Landed Cost Voucher/${record}`
  );
  return data;
});
export const getLandedCostVoucherDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Landed Cost Voucher/${id}`
  );
  return data;
});
export const getLandedCostVoucherItemsDerails = catchAsync(async (type, id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_items_from?type=${type}&id=${id}`
    // `/api/method/technoerp.services.get_items_from?type=Material Request&id=MAT-MR-2024-00008`
  );
  return data;
});
